import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { IntegrationV2EndpointsStore } from '../../features/integration-v2/services/integration-v2-endpoints.store';
import { ToastService } from '../services/toast.service';

const DENIED_MESSAGE = 'Custom document configuration is not enabled for your tenant.';

export const configureDocumentGuard: CanActivateFn = () => {
  const store = inject(IntegrationV2EndpointsStore);
  const router = inject(Router);
  const toast = inject(ToastService);

  return store.ensureLoaded().pipe(
    map(() => {
      if (store.configurableConfigurationAllowed()) return true;
      toast.error(DENIED_MESSAGE);
      return router.createUrlTree(['/integration']);
    }),
    catchError(() => {
      toast.error(DENIED_MESSAGE);
      return of(router.createUrlTree(['/integration']));
    }),
  );
};
